// Module
var code = "<div class=\"CheckboxListItem\"> <input type=\"checkbox\" ng-disabled=\"CheckboxListItem.disabled\" ng-model=\"CheckboxListItem.value\"/> <div class=\"CheckboxListItem__descriptors\"> <dt class=\"CheckboxListItem__label\">{{ CheckboxListItem.label }}</dt> <dd class=\"CheckboxListItem__description\"> {{ CheckboxListItem.description }} </dd> </div> </div> ";
// Exports
var _module_exports = code;;
var path = '@collectivehealth/frontend-member-v2/components/checkboxListItem/checkboxListItem.html';
var angular = require('angular');
angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;